import React, {createContext, useContext, useEffect, useState} from "react";
import {post} from "./utils";
import {Loading} from "./Loading";
import vkButton from "./vk.png";
import {Landing} from "./Landing/Landing";
import {Alert} from "@mui/material";
import {Dashboard} from "./Dashboard/Dashboard";

const AppContext = createContext({});
export const useAppContext = () => useContext(AppContext);

export const Main = () => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        post("https://ipresent.ru/api/vk-get-main-data/").then(setData).catch(setError);
    }, [])

    const VKButton = () => <input type="image" src={vkButton} alt={"Войти с VK ID"} style={{width: "100%", borderRadius: 8}}/>

    const onVKButtonClick = async (tariff_id) => {
        localStorage.setItem("tariff_id", tariff_id || "");
        localStorage.setItem("vk_code_verifier", data.vk.code_verifier);
        localStorage.setItem("vk_state", data.vk.state);
        window.location = data.vk.url
    }

    if (error) return <Alert color={"error"} title={error}>Ошибка: не удалось загрузить данные</Alert>
    if (!data) return <Loading/>;

    return (
        <AppContext.Provider value={{data, setData, onVKButtonClick, VKButton}}>
            {data.forbidden ? <Landing/> : <Dashboard vk={data.vk}/>}
        </AppContext.Provider>
    )
}
